<h1 class="content-main-title">{{ 'content.companies-administration' | translate }}</h1>
<app-item-list
  addNewRouterLink="/admin/companies/new"
  filterFormPlaceholder="{{ 'content.company-name' | translate }}"
  [canAddNew$]="guiPermissionsService.canCreateCompany$"
  [items]="companiesSubject"
  [searchMode]="'manual'"
  (filteredSortedItems)="onFilterSortUpdate($event)"
  (manualSearch)="searchForCompany($event)"
  >

  <table class="table table-striped">
    <caption>{{ 'content.companies-returned-by-search' | translate }}</caption>
    <thead>
      <tr>
        <th appSortable="companyName" scope="col">{{ 'content.company-name' | translate }}</th>
        <th appSortable="creationDate" scope="col">{{ 'content.created' | translate }}</th>
        <th appSortable="lastUpdatedBy" scope="col">{{ 'content.last-updated-by' | translate }}</th>
        <th scope="col">{{ 'content.options' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (company of filteredSortedCompanies; track company) {
        <tr>
          <th scope="row">
            @if ((guiPermissionsService.canViewCompany(company.companyName) | async)) {
              <a [routerLink]="['/admin/companies', company.companyName, 'details']" [state]="company">
                {{ company.companyName }}
              </a>
            } @else {
              <div>{{ company.companyName }}</div>
            }
          </th>
          <td>{{ reformatDate(company.creationDate, 'YYYY-MM-DD HH:mm:ss Z', 'YYYYMMDDHHmmssZ') }}</td>
          <td>{{ company.lastUpdatedBy }}</td>
          <td #deleteModalContainer class="inline-gap-3">
            @if (guiPermissionsService.canDeleteCompany$ | async) {
              <app-icon-button
                [ariaLabel]="'content.delete-company' | translate"
                [icon]="faTrash"
                [tooltip]="'content.delete-something' | translate:{ what:company.companyName }"
                (buttonClick)="delete(company, 'delete-company-dialog-label', deleteModalContainer)">
              </app-icon-button>
            }
            @if (guiPermissionsService.canEditCompany$ | async) {
              <app-icon-button
                element="link"
                [ariaLabel]="'content.edit-company' | translate"
                [icon]="faEdit"
                [routerLink]="['/admin/companies', company.companyName, 'edit']"
                [state]="company"
              [tooltip]="'content.edit-something' | translate:{ what:company.companyName }"></app-icon-button>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
  <span id="delete-company-dialog-label" class="d-none">{{ 'aria.confirm-delete-dialog' | translate }}</span>
</app-item-list>
